import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-6 sm:col-4 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_4 = { class: "field col-6 sm:col-4 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_5 = { class: "field col-6 sm:col-2 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_6 = { class: "field col-6 sm:col-3 md:col-3 lg:col-2 xl:col-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Issued invoices")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Received invoices")
], -1)

import {computed, inject, onMounted, reactive, Ref, ref} from "vue";
import {AxiosResponse, AxiosStatic} from "axios";
import moment from "moment";
import Dropdown from "primevue/dropdown";
import Panel from "primevue/panel";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {formatPrice} from "@/services/FormatService";
import {useUserStore} from "@/stores/UserStore";
import {MonthType, months} from "@/components/blocks/Types";

// Define types

type FormData = {
  year: number
  month: MonthType
}

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'DphView',
  setup(__props) {

const axios = inject<AxiosStatic>('axios')

// Define refs
const issuedInvoice = ref([])
const receivedInvoice = ref([])

const fii = ref<any[]>([])
const fri = ref<any[]>([])

const minYear = ref<number>(2000)
const maxYear = ref<number>(3000)

// Define reactive
const formData = reactive<FormData>({
  year: 2000,
  month: {index: 0, value: 'Leden'},
})

const store = useUserStore()


// Define lifecycle hooks
onMounted(() => {
  const m = moment().subtract(1, 'month')
  formData.month = {
    index: m.month(),
    value: months[m.month()]
  }
  axios?.get('/dph/issued-invoice').then(response => responseProcessor(response, issuedInvoice, 'i'))
  axios?.get('/dph/received-invoice').then(response => responseProcessor(response, receivedInvoice, 'r'))
})

// Define function
const responseProcessor = (response: AxiosResponse<any, any>, data: Ref, type: string): void => {
  if (response.status >= 200 && response.status <= 299) {
    data.value = response.data
    if (response.data.length > 0) {
      const lastRecord = moment(response.data[response.data.length - 1].issueDate)
      const firstRecord = moment(response.data[0].issueDate)
      minYear.value = Math.max(minYear.value, lastRecord.year())
      maxYear.value = Math.min(maxYear.value, firstRecord.year())
      formData.year = Math.max(maxYear.value)

      switch (type) {
        case 'i':
          fii.value = filterBySelectedDate(data.value);
          break;
        case 'r':
          fri.value = filterBySelectedDate(data.value);
          break;
      }
    }
  } else {
    console.error('Can not load issued invoice')
  }
}

function handleSubmit() {
  fii.value = filterBySelectedDate(issuedInvoice.value)
  fri.value = filterBySelectedDate(receivedInvoice.value)
}

function filterBySelectedDate(input: Array<any>): Array<any> {
  return input.filter(value => {
    const m = moment(value.issueDate)
    return m.month() == formData.month.index && m.year() == formData.year
  })
}

function processContentDownload() {

  const path = formData.year+'-'+(formData.month.index + 1).toString(10).padStart(2,'0')+'-01'

  axios?.get('/dph/download/' + path + '/' + store.userDetail.company, {
    responseType: 'blob'
  }).then(response => {
    const objectURL = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = objectURL
    link.setAttribute('download', 'dph-' + path + '.zip')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(link.href)

  }).catch(error => {
    alert('Error while downloading file')
    console.error(error)
  })
}

// Define enumerated
const computedYears = computed(() => {
  const years = []
  for (let a = minYear.value; a <= maxYear.value; a++) {
    years.push(a)
  }
  return years
})

const computedMonths = computed(() => {
  return months.map((_item, _index) => {
    return {
      index: _index,
      value: _item
    } as MonthType
  })
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Panel), {
      header: "Select month",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleSubmit()), ["prevent"])),
          class: "p-fluid"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Dropdown), {
                  modelValue: formData.year,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.year) = $event)),
                  options: _unref(computedYears)
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(Dropdown), {
                  modelValue: formData.month,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.month) = $event)),
                  optionLabel: "value",
                  options: _unref(computedMonths)
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Button), {
                  type: "submit",
                  label: "Select"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Button), {
                  icon: "pi pi-download",
                  type: "button",
                  label: "Download",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (processContentDownload()))
                })
              ])
            ])
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(_unref(DataTable), {
      class: "mt-2",
      rowHover: true,
      ref: "dt",
      dataKey: "id",
      value: fii.value,
      totalRecords: fii.value.length
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "NUMBER"
        }),
        _createVNode(_unref(Column), {
          field: "issueDate",
          header: "ISSUE DATE"
        }),
        _createVNode(_unref(Column), {
          field: "vatPaymentDate",
          header: "VAT PAYMENT DATE"
        }),
        _createVNode(_unref(Column), {
          field: "paymentDate",
          header: "PAYMENT DATE"
        }),
        _createVNode(_unref(Column), {
          field: "issuerName",
          header: "ISSUER"
        }),
        _createVNode(_unref(Column), {
          field: "recipientName",
          header: "RECIPIENT"
        }),
        _createVNode(_unref(Column), { header: "PRICE" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "TOTAL PRICE" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.totalPrice)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "VAT" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.vatAmount)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords"]),
    _createVNode(_unref(DataTable), {
      class: "mt-2",
      rowHover: true,
      ref: "dt",
      dataKey: "id",
      value: fri.value,
      totalRecords: fri.value.length
    }, {
      header: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "number",
          header: "NUMBER"
        }),
        _createVNode(_unref(Column), {
          field: "issueDate",
          header: "ISSUE DATE"
        }),
        _createVNode(_unref(Column), {
          field: "vatPaymentDate",
          header: "VAT PAYMENT DATE"
        }),
        _createVNode(_unref(Column), {
          field: "paymentDate",
          header: "PAYMENT DATE"
        }),
        _createVNode(_unref(Column), {
          field: "issuerName",
          header: "ISSUER"
        }),
        _createVNode(_unref(Column), {
          field: "recipientName",
          header: "RECIPIENT"
        }),
        _createVNode(_unref(Column), { header: "PRICE" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "TOTAL PRICE" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.totalPrice)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "VAT" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_unref(formatPrice)(data.vatAmount)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords"])
  ], 64))
}
}

})